var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tooltip",style:(_vm.flexClass)},[_vm._t("default"),_c('div',{staticClass:"cf-text tooltiptext",class:_vm.tooltipClass},[_vm._v(_vm._s(_vm.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }